import React from "react";
import List from "@material-ui/core/List";
import ListSubheader from "@material-ui/core/ListSubheader";
import { PatScoreType } from "@prestosports/prestostats-core/Football";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
		maxWidth: 360,
		maxHeight: 400,
		overflow: "auto",
		backgroundColor: theme.palette.background.paper
	}
}));

const PatScoreTypeSelector = ({ onSelected }) => {
	const classes = useStyles();

	const selectPatScoreType = (patScoreType) => {
		onSelected(patScoreType);
	};

	return (
		<List
			className={classes.root}
			aria-labelledby="pat-score-type-list-subheader"
			subheader={
				<ListSubheader component="div" id="pat-score-type-list-subheader">
					Pat score type
				</ListSubheader>
			}
		>
			{Object.values(PatScoreType).map((p) => (
				<ListItem button onClick={() => selectPatScoreType(p)} key={p.code}>
					<ListItemText primary={p.name} />
				</ListItem>
			))}
		</List>
	);
};

export default PatScoreTypeSelector;
